import React from 'react';
import { Grid, Skeleton } from '@mui/material';

function PhotoLoadingGrid() {
  return (
    <Grid container spacing={2}>
      {Array.from({ length: 8 }).map((_, index) => (
        <Grid item xs={12} sm={4} md={3} key={index}>
          <Skeleton
            variant="rectangular"
            sx={{
              aspectRatio: '3/4',
              borderRadius: 2,
              width: '100%',
              height: 'auto',
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
}

export default PhotoLoadingGrid;
